import { ButtonProps as AntdButtonProps, Button as ButtonAntd } from 'antd'
import * as React from 'react'

import { UIManager } from '@/Core/Managers/UI/UIManager'
import { useProfiler } from '../../Utils/profilerHelpers'
import { MergeConfigAndPropsTask } from '@/Core/Tasks/Utils/MergeConfigAndPropsTask'
import { configManager } from '@/Core/Managers/Config/ConfigManager'

export interface ButtonProps extends Omit<AntdButtonProps, 'children'> {
    children?: React.ReactNode
}

export const Button: React.FC<ButtonProps> = ({ ...props }) => {
    // Интеграция с профайлером в dev режиме
    const { addEvent, setStatus } = useProfiler('Button', 'component', '/Core/UI/Button/Button.tsx', [props])

    React.useEffect(() => {
        setStatus('active')
        addEvent('initialized', { props })
    }, [])

    const buttonConfig = configManager.get('ButtonConfig', {})
    
    props = MergeConfigAndPropsTask({
        buttonConfig,
        props,
    });

    const uiManager = new UIManager({
        template: ButtonAntd,
        ...props,
        isObservable: true,
    })

    return uiManager.render()
}

export default Button
